import { IDashboardComponent, IDashboardMetadata } from '../dashboard-metadata.service';
import { IReportAggregates } from '../../../../shared/report/report-data.service';
import { ActivationKpiInfoComponent } from '../info/activation-kpi-info.component';
import { ActivationDashboardFiltersComponent } from '../filters/activation/activation-dashboard-filters.component';
import { ActivationKpiFooterComponent } from '../footer/activation-kpi-footer.component';

const columns:string[] = [
  'Lacomnm',
  'Delamnm',
  'Delamcn',
  'Desprnm',
  'Destaco_curr',
  'Destadt_curr',
  'Deforus_curr',
  'Decatav_ds_curr',
  'Molname'
];

const aggregates:IReportAggregates = {
  sum: true
};

const infoComponent:IDashboardComponent = {
  name: ActivationKpiInfoComponent
};

export const ACTIVATION_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'ACTIVATION KPI',
  filterComponent: {
    name: ActivationDashboardFiltersComponent
  },
  footerComponent: {
    name: ActivationKpiFooterComponent
  },
  mapping: {
    Desprnm: 'customer.id',
    Delamnm: 'lam.id',
    Lacomnm: 'lamCompany.id',
    Delamcn: 'lamContact.id',
    Molname: 'gbdm.firstname + " " + gbdm.lastname',
    Demoddt_FROM: 'date_FROM',
    Demoddt_TO: 'date_TO'
  },
  reports: [
    {
      id: 247,
      key: 'NEW_ACTIVATIONS',
      code: 'ACTIVATIONS',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@ACT@',
        Desprst_ds_prev: '@PRESALES@@STEADY@@SLEEP@@CLOSED@@TOAPPROVE@@EMPTY@'
      },
      columns: [
        'Lacomnm',
        'Delamnm',
        'Delamcn',
        'Desprnm',
        'Destaco_curr',
        'Destadt_curr',
        'Deforus_curr',
        'Decatav_ds_curr',
        'Molname',
        'Desprst_ds_prev'
      ],
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'SETUP_LIVE',
      code: 'SETUP_LIVE',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@STEADY@',
        Desprst_ds_prev: '@ACT@'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'SETUP_NEW',
      code: 'SETUP_NEW',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@PRESALES@',
        Desprst_ds_prev: '@ACT@'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'SETUP_SLEEP',
      code: 'SETUP_SLEEP',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@SLEEP@',
        Desprst_ds_prev: '@ACT@'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'SETUP_CLOSE',
      code: 'SETUP_CLOSE',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@CLOSED@',
        Desprst_ds_prev: '@ACT@'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'CATALOG_NO_YES',
      code: 'CATALOG_NO_YES',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Decatav_ds: '1',
        Decatav_ds_prev: '0'
      },
      columns,
      aggregates,
      infoComponent
    }

  ]
};